"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function arg(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M8.02772 3.96699C9.88142 3.04759 11.9964 2.79873 14.0128 3.26273C16.0293 3.72674 17.8228 4.87496 19.0882 6.51209C20.3536 8.14922 21.0128 10.1742 20.9537 12.2425C20.8946 14.3108 20.1208 16.2948 18.764 17.857C18.3177 16.885 17.9757 15.8657 17.5932 14.8622L15.2832 8.80974C15.0605 8.19624 14.6862 7.60674 14.105 7.28799C13.2911 6.89562 12.379 6.75412 11.4845 6.88149C10.7675 6.96174 10.019 7.20849 9.53297 7.77399C9.07097 8.30724 8.86397 8.99274 8.60147 9.63774L6.93647 13.8587C6.37922 15.1967 5.90897 16.5827 5.30372 17.9125C4.43191 16.9709 3.79126 15.8393 3.43247 14.6072C2.81249 12.5747 2.93506 10.3879 3.7783 8.43742C4.62155 6.48688 6.13057 4.89953 8.03597 3.95874L8.02772 3.96624V3.96699Z", fill: color }),
        React.createElement("path", { d: "M11.357 10.0675C11.516 9.58974 12.1535 9.42999 12.5675 9.70149C12.7902 9.86874 12.8705 10.1552 12.974 10.4102C14.009 13.1177 15.029 15.8417 16.0565 18.5582C16.1915 18.9482 16.3902 19.3225 16.4705 19.7282C16.4053 19.7977 16.3299 19.8569 16.247 19.9037C15.1233 20.5049 13.8844 20.86 12.6128 20.9452C11.3413 21.0304 10.0661 20.8439 8.87222 20.398C8.42597 20.2142 7.96472 20.0552 7.57397 19.7762C7.61372 19.4102 7.79673 19.0832 7.93248 18.7487C9.07922 15.8582 10.202 12.9587 11.357 10.0675Z", fill: color }));
}
exports["default"] = arg;
//# sourceMappingURL=arg.js.map